import types from "./types";

export function nextPage() {
  return {
    type: types.NEXT_PAGE,
  };
}

export function previousPage() {
  return {
    type: types.PREVIOUS_PAGE,
  };
}

export function setCurrentPage(page) {
  return {
    type: types.SET_CURRENT_PAGE,
    page,
  };
}

export function toggleModal(bool) {
  return {
    type: types.TOGGLE_MODAL,
    bool,
  };
}

export function resetModalState() {
  return {
    type: types.RESET_MODAL_STATE,
  };
}
